import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import PdfHeader from './componet/PdfHeader';
import PdfContent from './componet/PdfContent';
import PdfFooter from './componet/PdfFooter';
import ep1_ko from './webtoon/ep1_ko.pdf';
import ep2_ko from './webtoon/ep2_ko.pdf';
import ep3_ko from './webtoon/ep3_ko.pdf';
import ep4_ko from './webtoon/ep4_ko.pdf';
import ep1_en from './webtoon/ep1_en.pdf';
import ep2_en from './webtoon/ep2_en.pdf';
import ep3_en from './webtoon/ep3_en.pdf';
import ep4_en from './webtoon/ep4_en.pdf';
import './componet/PdfViewer.css';

const pdfFilesKo = [ep1_ko, ep2_ko, ep3_ko, ep4_ko];
const pdfFilesEn = [ep1_en, ep2_en, ep3_en, ep4_en];
const pdfTitlesKo = [
  "1화. 버림받은 사람들",
  "2화. 인공수재와 자연수재",
  "3화. 나방",
  "4화. 압록강의 노래"
];
const pdfTitlesEn = [
  "ep1. Abandoned People",
  "ep2. Artificial Genius and Natural Genius",
  "ep3. Moth",
  "ep4. Song of the Amnok River"
];

const PdfViewer = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // URL 쿼리 매개변수에서 언어 상태와 인덱스를 가져옵니다.
  const query = new URLSearchParams(location.search);
  const initialLanguage = query.get('lang') || 'en';
  const initialIndex = parseInt(query.get('index'), 10) || 0; // default index is 0

  const [language, setLanguage] = useState(initialLanguage);
  const [currentPdfIndex, setCurrentPdfIndex] = useState(initialIndex);

  const alertMessages = {
    ko: '조회할 콘텐츠가 없습니다.',
    en: 'No content to view.'
  };

  const handlePrevious = () => {
    if (currentPdfIndex > 0) {
      setCurrentPdfIndex((prevIndex) => prevIndex - 1);
      query.set('index', currentPdfIndex - 1);
      navigate({ search: query.toString() });
    } else {
      alert(alertMessages[language]);
    }
  };

  const handleNext = () => {
    if (currentPdfIndex < pdfFilesKo.length - 1) {
      setCurrentPdfIndex((prevIndex) => prevIndex + 1);
      query.set('index', currentPdfIndex + 1);
      navigate({ search: query.toString() });
    } else {
      alert(alertMessages[language]);
    }
  };

  const handleLanguageChange = (lang) => {
    setLanguage(lang);
    // URL 쿼리 매개변수를 업데이트합니다.
    query.set('lang', lang);
    navigate({ search: query.toString() });
  };

  useEffect(() => {
    setLanguage(initialLanguage);
    setCurrentPdfIndex(initialIndex);
  }, [initialLanguage, initialIndex]);

  const pdfFiles = language === 'ko' ? pdfFilesKo : pdfFilesEn;
  const pdfTitles = language === 'ko' ? pdfTitlesKo : pdfTitlesEn;

  return (
    <div className="pdf-viewer-container">
      <PdfHeader title={pdfTitles[currentPdfIndex]} onLanguageChange={handleLanguageChange} language={language} />
      <PdfContent fileUrl={pdfFiles[currentPdfIndex]} />
      <PdfFooter onPrevious={handlePrevious} onNext={handleNext} />
    </div>
  );
}

export default PdfViewer;
